import { EMAIL_TABLE_STYLES } from "@/constants/email";

function prependStyle(element: Element, style: string): void {
  const ownStyle = element.getAttribute("style")?.trim() ?? "";
  const separated = ownStyle && !ownStyle.endsWith(";") ? `${ownStyle};` : ownStyle;

  element.setAttribute("style", `${style} ${separated}`.trim());
}

export function setInlineEmailTableStyles(html: string): string {
  if (!html.includes("<table")) {
    return html;
  }

  const parsed = new DOMParser().parseFromString(html, "text/html");
  const tables = Array.from(parsed.body.querySelectorAll("table"));

  if (!tables.length) {
    return html;
  }

  tables.forEach((table) => {
    table.setAttribute("border", "0");
    table.setAttribute("cellpadding", "0");
    table.setAttribute("cellspacing", "0");

    prependStyle(table, EMAIL_TABLE_STYLES.table);

    table.querySelectorAll("th").forEach((cell) => prependStyle(cell, EMAIL_TABLE_STYLES.th));
    table.querySelectorAll("td").forEach((cell) => prependStyle(cell, EMAIL_TABLE_STYLES.td));
    table.querySelectorAll("p").forEach((paragraph) => prependStyle(paragraph, EMAIL_TABLE_STYLES.paragraph));
  });

  return parsed.body.innerHTML;
}
